import { render, staticRenderFns } from "./_userControls.vue?vue&type=template&id=39d52f98"
import script from "./_userControls.vue?vue&type=script&lang=js"
export * from "./_userControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports